import React from "react"
import { Link } from "gatsby"
import { motion } from "framer-motion"

const CoffeeMug = () => (
  <svg
    className="w-6 h-6 lg:w-8 lg:h-8 flex-shrink-0 fill-current"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 600 600"
  >
    <path d="M422 211v-30H30v75c0 69.501 36.669 131.461 91.558 166h207.884c13.48-8.483 26.829-18.594 37.837-30H407c57.891 0 105-47.109 105-105v-76h-90zm60 76c0 41.353-33.647 75-75 75h-16.326C410.287 331.652 422 294.763 422 256v-15h60v46zM0 452c0 33.137 26.863 60 60 60h332c33.137 0 60-26.863 60-60H0z" />
    <g id="steam">
      <path d="M160.068 0l-16.641 24.961c5.962 3.97 9.375 10.356 9.375 17.52s-3.413 13.55-9.375 17.52c-14.238 9.492-22.734 25.371-22.734 42.48 0 17.109 8.496 32.988 22.734 42.48L160.067 120c-5.962-3.97-9.375-10.356-9.375-17.52s3.413-13.55 9.375-17.52c14.239-9.491 22.735-25.37 22.735-42.48 0-17.109-8.496-32.988-22.734-42.48zM235.068 0l-16.641 24.961c5.962 3.97 9.375 10.356 9.375 17.52s-3.413 13.55-9.375 17.52c-14.238 9.492-22.734 25.371-22.734 42.48 0 17.109 8.496 32.988 22.734 42.48L235.067 120c-5.962-3.97-9.375-10.356-9.375-17.52s3.413-13.55 9.375-17.52c14.239-9.491 22.735-25.37 22.735-42.48 0-17.109-8.496-32.988-22.734-42.48zM310.068 0l-16.641 24.961c5.962 3.97 9.375 10.356 9.375 17.52s-3.413 13.55-9.375 17.52c-14.238 9.492-22.734 25.371-22.734 42.48 0 17.109 8.496 32.988 22.734 42.48L310.067 120c-5.962-3.97-9.375-10.356-9.375-17.52s3.413-13.55 9.375-17.52c14.239-9.491 22.735-25.37 22.735-42.48 0-17.109-8.496-32.988-22.734-42.48z" />
    </g>
  </svg>
)

function FadeInWhenVisible({ children }) {
  return (
    <motion.div
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true }}
      transition={{ duration: 0.5 }}
      variants={{
        visible: { opacity: 1, scale: 1 },
        hidden: { opacity: 0, scale: 0 },
      }}
    >
      {children}
    </motion.div>
  )
}

//"All Posts"
const Posts = ({ content }) => {

  const { frontmatter, fields, excerpt, timeToRead } = content
  return (
    <li
      id="blogs"
      key={fields.slug}
      className="my-8 mx-auto snap-center scroll-mt-44 lg:scroll-mt-60 px-4 lg:px-0"
    >
      <article className="flex flex-col rounded-lg my-6">
        <header>
          <Link to={fields.slug}  itemProp="url" aria-label={frontmatter.slug}>
            {frontmatter.bannerUrl ? (
            <div className="flex-shrink-0 cursor-pointer transition duration-300 ease-in-out transform  hover:ring-2 ring-offset-blue-200 dark:ring-offset-gray-600  hover:ring-offset-blue-500 dark:hover:ring-offset-white ring-offset-2 rounded-lg p-2">
              <img 
                src={frontmatter.bannerUrl}
                alt={frontmatter.keywords}
                className="aspect-[1/1] w-full object-cover rounded-md shadow-xl"
              />
              {/* {frontmatter.bannerCredit ? <Markdown>{frontmatter.bannerCredit}</Markdown> : null} */}
            </div>
            ) : null}
            <h2 className="mt-4 font-body2 lg:mt-6 font-medium text-xl lg:text-3xl text-quarternary text-start">{frontmatter.title}</h2>
            <p className="flex font-medium text-lg lg:text-2xl text-secondary-text text-start mt-2">
              {frontmatter.date}<span className="">&nbsp;&bull;&nbsp;{timeToRead} mins read &bull;&nbsp;</span>
              <div className="inline-block flex-shrink-0">
                <CoffeeMug />
              </div>
            </p>
          </Link>
          <section>
            <p
              className="flex font-medium text-md md:text-lg lg:text-xl text-secondary-text text-start mt-4 "
              dangerouslySetInnerHTML={{
                __html: frontmatter.description || excerpt
              }}
            />
          </section>
        </header>
      </article>
      {/* {!cta ? null : (
        <Link to="/blog" className="flex justify-center">
          <button className="mt-10 inline-block w-auto font-bold text-sm sm:text-md md:text-lg lg:text-2xl cursor-pointer transition duration-300 ease-in-out transform hover:-translate-y-1 hover:scale-100 border-2 border-blue-200 dark:border-gray-600  hover:border-blue-500 dark:hover:border-white rounded-full">
            <div class="flex flex-cols-1">
                <span className="relative flex items-center justify-center w-full h-full whitespace-nowrap text-secondary-text hover:text-quarternary px-6 py-4 space-x-3 md:px-11 md:py-6 md:space-x-5">See more blogs</span>
            </div> 
          </button>
        </Link>
      )} */}
    </li>
  )
}

export default Posts
